<template>
  <div>
    <vs-alert :active.sync="errorOccurred" color="danger" title="Error While Loading Lesson">
      <span>We were unable to load Lesson with Id {{ $route.params.setId }} successfully.</span>
    </vs-alert>
    <div v-if="!errorOccurred">
      <div v-if="setData">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vx-card>
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <img class="mr-4 rounded" :src="setData.thumbnail" v-if="setData.thumbnail" width="40" height="40" />
                  <h1 class="">{{ setData.name }}</h1>
                </div>
                <div class="flex justify-end items-center">
                  <feather-icon v-if="autoSave.status === 'success'" icon="CheckIcon" svgClasses="h-5 w-5 text-success mr-2" />
                  <div v-else-if="autoSave.status === 'pending'" class="vs-con-loading__container h-5 w-5 mr-2" id="pendingLoadingCircle" />
                  <feather-icon v-else icon="XCircleIcon" svgClasses="h-5 w-5 text-danger mr-2" />
                  <p class="cursor-pointer" @click="saveChanges">{{ autoSave.text }}</p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>

      <div v-else class="simple-spinner">
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress';
import LottieAnimation from '../../../../../../../components/lottie/LottieAnimation';
import draggable from 'vuedraggable';

export default {
  data() {
    return {
      dragging: false,

      setData: null,

      statusOptions: ['active', 'hidden', 'disabled'],

      errorOccurred: false,

      autoSave: {
        status: 'success',
        text: 'Ready To Save',
      },
    };
  },
  computed: {
    lessonColorProgress() {
      const theme = this.$store.state.theme;
      if (theme === 'light') return 'rgba(0,0,0,0.2)';
      if (theme === 'dusk') return 'rgba(0,0,0,0.5)';
      if (theme === 'dark') return 'rgba(0,0,0,0.2)';
    },
  },
  components: {
    RadialProgressBar,
    LottieAnimation,
    draggable,
  },
  methods: {
    fetchSetDetails(id) {
      this.$http
        .get(`study/set/${id}?rich=true`)
        .then((response) => {
          if (response.status === 200) {
            this.setData = response.data;
          }
        })
        .catch(() => {
          this.errorOccurred = true;
        });
    },
    lottiePlay(ref) {
      this.$refs[ref][0].play();
    },
    lottieStop(ref) {
      this.$refs[ref][0].stop();
    },
    copyText(x) {
      const thisIns = this;
      this.$copyText(x).then(function () {
        thisIns.$vs.notify({
          title: 'Success',
          text: 'Copied To Clipboard',
          color: 'success',
          iconPack: 'feather',
          position: 'bottom-right',
          icon: 'icon-clipboard',
        });
      });
    },
    saveChanges(update) {
      this.autoSave = {
        text: 'Saving...',
        status: 'pending',
      };

      setTimeout(() => {
        this.$vs.loading({
          color: '#FF9F43',
          background: 'transparent',
          container: '#pendingLoadingCircle',
          scale: 0.325,
          type: 'point',
        });
      }, 1);

      if (update.includes('practice')) {
        const pl = [];
        this.practiceData.lessons.forEach((lesson) => {
          pl.push(lesson.id);
        });
        this.$http.post(`practice/${this.practiceData.id}`, pl).catch(() => {
          this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading');
          this.autoSave = {
            text: 'Error While Saving Changes',
            status: 'error',
          };
        });
      }

      setTimeout(() => {
        this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading');
        const date = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric' });
        this.autoSave = {
          text: `All Changes Saved - ${date.format(new Date())}`,
          status: 'success',
        };
      }, 2500);
    },
  },
  created() {
    this.fetchSetDetails(this.$route.params.setId);
    this.fetchLessonsList();

    setTimeout(() => {
      this.currentStep = 1;
    }, 1500);
  },
};
</script>

<style lang="scss">
.theme-dark {
  #CreateLessonPopup {
    input.vs-inputx.vs-input--input {
      background: #1b1e22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}
</style>
